import React, { useEffect } from 'react';
import logo from '../../assets/images/wrenchboard.png';
import StickyMenu from '../../lib/StickyMenu';
import Navigation from '../Navigation';
import getConfig from './../../Config/config'

// wrench-users (sign in / sign up) — same pattern as wrench-www's
// HomeOneHeader.tsx. Falls back to wrench-users' local dev port since
// this var isn't set in docker-compose.yml (Dockerfile.prod bakes it as
// a runtime sentinel instead — see docker-entrypoint.sh).
const DASH_URL_LOGIN = process.env.REACT_APP_DASH_URL_LOGIN || 'http://localhost:21014';

function HeaderNews({ action }) {
    var site = getConfig()[0];
    useEffect(() => {
        StickyMenu();
    });
    return (
        <>
            <header className="appie-header-area appie-header-page-area appie-sticky">
                <div className="container">
                    <div className="header-nav-box header-nav-box-3 header-nav-box-inner-page">
                        <div className="row align-items-center">
                            <div className="col-lg-2 col-md-4 col-sm-5 col-6 order-1 order-sm-1">
                                <div className="appie-logo-box">
                                    <a href="/">
                                        <img src={logo} alt="" />
                                    </a>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-1 col-sm-1 order-3 order-sm-2">
                                <div className="appie-header-main-menu">
                                    <Navigation />
                                </div>
                            </div>
                            <div className="col-lg-4  col-md-7 col-sm-6 col-6 order-2 order-sm-3">
                                <div className="appie-btn-box text-right">
                                    {/* wrench-users' own flow covers both login and signup
                                        (RES/TODO/TODO-Links-Cleanup.md) — same as wrench-www's
                                        header, so there's no separate Login button. */}
                                    <a className="main-btn ml-30" href={DASH_URL_LOGIN}>
                                        Get Started
                                    </a>
                                    <div
                                        onClick={(e) => action(e)}
                                        className="toggle-btn ml-30 canvas_open d-lg-none d-block"
                                    >
                                        <i className="fa fa-bars"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
}

export default HeaderNews;
